import router from '@/router'
import store from '@/store'
import { getSupportFileType } from '@/api/onlineEdit.api'
import {
  getUserPerm,
  addDownLog,
  validateFilePermByUserId,
  getProjectById
} from '@/api/permission.api'

export default {
  getUUID(randomLength = 10) {
    return Number(Math.random().toString().substring(2, randomLength) + Date.now()).toString(36)
  },
  // 处理文件单位展示
  handleFileSize(limit) {
    if (limit == null) {
    } else {
      let size = ''
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = `${limit.toFixed(2)}B`
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = `${(limit / 1024).toFixed(2)}KB`
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = `${(limit / (1024 * 1024)).toFixed(2)}MB`
      } else {
        // 其他转化成GB
        size = `${(limit / (1024 * 1024 * 1024)).toFixed(2)}GB`
      }

      const sizeStr = `${size}` // 转成字符串
      const index = sizeStr.indexOf('.') // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
      if (dou == '00') {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size
    }
  },

  // 路由正则
  getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },

  // 判断文件夹名称是否规范, 规范返回 true
  checkFolderName(name) {
    if (!name) return {
      name: '',
      result: false
    }
    const reg = /[\\\/:*?？"<>|]/g;
    const replaceRes = name.trim().replace(reg, '');
    let res = false
    // 判断是否还有字符并且不超过250字符
    if (replaceRes.length > 0 && replaceRes.length <= 250) {
      res = true
    }
    return {
      result: res,
      name: replaceRes
    }
  },

  /**
   * * 文档格式支持
   * @param {string} fileType 文件后缀
   * @returns {boolean}
   */
  async webOnlineEditCheckFileType(fileType) {
    // * 获取多人在线编辑文件类型
    const _fileSuffix = await getSupportFileType()
    let result = _fileSuffix.data.some(item => {
      return item === fileType.toLowerCase()
    })
    return result
  },

  /**
   * * 根据文件后缀返回类型缩写
   * @param {string} fileType 完整的文件后缀名
   * @return  文字文件:w, 表格文件:s, 演示文件:p, PDF文件:f
   */
  handleFileSuffixType(fileType) {
    const fileTypeLow = fileType.toLowerCase()
    const f = 'pdf'
    // 表格
    const s = ['xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm']
    // 文档
    const w = [
      'doc',
      'dot',
      'wps',
      'wpt',
      'docx',
      'dotx',
      'docm',
      'dotm',
      'rtf',
    ]
    // 演示
    const p = [
      'ppt',
      'pptx',
      'pptm',
      'ppsx',
      'ppsm',
      'pps',
      'potx',
      'dpt',
      'dps'
    ]
    if (fileTypeLow === f) return 'f'
    if (s.findIndex(e => e === fileTypeLow) !== -1) return 's'
    if (w.findIndex(e => e === fileTypeLow) !== -1) return 'w'
    if (p.findIndex(e => e === fileTypeLow) !== -1) return 'p'
    // 没有找到
    return null
  },

  /**
   * ! 获取系统权限，返回 promise
   * @returns {*} promise
   */
  getUserPermPromise() {
    const typeObj = {
      token: store.getters.loginObject.token,
      userId: store.getters.loginObject.userId,
      projectId: ''
    }
    return getUserPerm(typeObj)
      .then(
        res => {
          if (res.code !== 0) {
            return
          }
          if (!res.data.length) {
            return
          }
          return res.data
        },
        rej => {
          return
        }
      )
      .catch(err => {
        console.log(err)
      })
  },

  // ! 项目文档下载权限判断
  canOperating(keyName) {
    const {
      projectId,
      userToken,
      userId,
      id,
      fileId,
      loginType
    } = store.state.routeInfo
    const canOperatingParams = {
      projectId,
      userId,
      loginType,
      token: userToken,
      data: {
        ids: fileId || id, // 项目文档版本预览时id为版本的id  非当前文件的主键id 此时 主键id为fileId
        key: keyName,
        docSource: 0
      }
    }
    return validateFilePermByUserId(canOperatingParams).then(
      res => {
        // * 注意这里的返回（旧代码的）
        return false
      },
      err => {
        if (err.code !== 0) {
          return true
        }
      }
    )
  },

  /**
   * ! 根据权限编码判断是否有--系统权限
   * @param p 权限编码
   * @returns {boolean} 是否有权限
   */
  checkSystemPermission(p) {
    if (!p) {
      return false
    }
    // 获取权限列表
    const list = store.state.systemPerm
    if (!list || !list.length) return false
    // 判断权限列表中是否包含当前权限编码
    const idx = list.findIndex(v => v === p)

    return idx > -1
  },

  // * 校验项目文档预览权限
  async checkPreviewPermission(queryData) {

    // 校验文件创建人信息
    if(queryData.createBy === queryData.userId) return true

    // 校验项目创建人
    const projectInfo = await this.checkProjectById(queryData)
    if (projectInfo) return true

    // 右键设置的预览权限（这里注意返回值是相反的）
    const apiPermisstion = await this.canOperating('view')
    if (!apiPermisstion) return true

    // 预览权限
    if (this.checkSystemPermission('project_file_show')) return true

    // 编辑预览权限 
    if (this.checkSystemPermission('project_file_deit')) return true

    return false
  },

  // * 校验项目创建人信息
  async checkProjectById(queryData) {
    const res = await getProjectById({
      data: {
        id: queryData.projectId
      }
    })
    return res.createBy === queryData.userId
  },

  // * 记录下载日志
  downloadLog(file, docSource) {
    let downLogList = []
    downLogList.push({
      id: store.state.routeInfo.id,
      docId: store.state.routeInfo.docId,
      docType: 0,
      version: store.state.routeInfo.version
    })
    const data = {
      data: {
        docSource,
        downLogList
      }
    }
    addDownLog(data)
      .then(() => {})
      .catch(() => {})
  },

  // * 删除class节点
  deleteDomByClass(className) {
    let dom = document.querySelectorAll(`.${className}`)
    if (dom.length) {
      try {
        dom.forEach(e => {
          e.remove()
        })
      } catch (err) {
        console.log(err)
      }
    }
  },

  // * 跳转到登录界面
  windowToLogin() {
    const { origin} = document.location
    history.replaceState('','',`${origin}/#/login`)
    router.go(1)
    window.location.reload()
  },

  // * 重定向当前界面(webOnlineEdit/page/error)
  windowToAllSelfPage(path) {
    const { origin, pathname} = document.location
    history.replaceState('','',`${origin}${pathname}#/${path}`)
    router.go(1)
    window.location.reload()
  },

  // * 跳转到错误信息提示界面
  toErrorMessagePage(message = null) {
    router.replace(`/webOnlineEdit/page/error/${message}`)
  },

  // * 跳转到服务错误界面
  toServerErrorPage() {
    const docId = store.state.routeInfo.docId
    const userId = store.state.routeInfo.userId
    const urlHash = document.location.hash
    const _toPathArray = urlHash.split('/')

    // 断网界面不支持跳转
    const toPathHasNotline =
      (_toPathArray && _toPathArray.findIndex(e => e === 'notline') !== -1) ||
      false
    if (!toPathHasNotline) return
    if (docId && userId) {
      router.replace(`/webOnlineEdit/server/error/${docId}/${userId}`)
    } else {
      router.replace(`/webOnlineEdit/page/error`)
    }
  },

  // * 跳转到断网界面
  toNotLinePage() {
    let docId = store.state.routeInfo.docId
    let userId = store.state.routeInfo.userId
    if (docId && userId) {
      router.replace(`/webOnlineEdit/server/error/${docId}/${userId}`)
      return
    }
    // 如果没有值就从头部获取
    const urlHash = document.location.hash
    const _toPathArray = urlHash.split('/')
    docId = _toPathArray && _toPathArray[_toPathArray.length - 2]
    userId = _toPathArray && _toPathArray[_toPathArray.length - 1]
    if (docId && userId) {
      router.replace(`/webOnlineEdit/server/error/${docId}/${userId}`)
    } else {
      this.toErrorMessagePage('用户身份已过期，请在联网后关闭界面重新登录！')
    }
  },

  // * 跳转到编辑（当前界面没有userId和docId就不要调这个函数了）
  toEditPage() {
    const urlHash = document.location.hash
    const _toPathArray = urlHash.split('/')
    const docId = _toPathArray && _toPathArray[_toPathArray.length - 2]
    const userId = _toPathArray && _toPathArray[_toPathArray.length - 1]

    // 判断当前是否已经在edit界面
    const toPathHasEdit = _toPathArray && _toPathArray.findIndex(e => e === 'edit') !== -1

    if (docId && userId) {
      if (toPathHasEdit) {
        window.location.reload()
        return
      }
      router.replace(`/webOnlineEdit/edit/${docId}/${userId}`)
      return
    }
    // 没有用户数据
    router.replace(`/webOnlineEdit/page/error`)
  },

  // * 并发请求
  pLimit(concurrency){
    const queue = [];
    let activeCount = 0;
  
    const next = () => {
      activeCount--;
  
      if (queue.length > 0) {
        queue.shift()();
      }
    };
  
    const run = async (fn, resolve, ...args) => {
      activeCount++;
  
      const result = (async () => fn(...args))();

      resolve(result);
  
      try {
        await result;
      } catch(e) {
        console.log(e)
      }

      next();
    };
  
    const enqueue = (fn, resolve, ...args) => {
      queue.push(run.bind(null, fn, resolve, ...args));
  
      if (activeCount < concurrency && queue.length > 0) {
          queue.shift()();
      }
    };
  
    const generator = (fn, ...args) =>
      new Promise((resolve) => {
        enqueue(fn, resolve, ...args);
      });
  
    return generator;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js